// Utility to convert numbers to French words for Algerian invoices

const units = [
  '', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'
];

const teens = [
  'dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 
  'dix-sept', 'dix-huit', 'dix-neuf'
];

const tens = [
  '', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 
  'soixante-dix', 'quatre-vingt', 'quatre-vingt-dix'
];

const convertHundreds = (num) => {
  let result = '';
  
  const hundreds = Math.floor(num / 100);
  const remainder = num % 100;
  
  if (hundreds > 0) {
    if (hundreds === 1) {
      result += 'cent';
    } else {
      result += units[hundreds] + ' cent';
    }
    if (hundreds > 1 && remainder === 0) {
      result += 's';
    }
  }
  
  if (remainder > 0) {
    if (result) result += ' ';
    
    if (remainder < 10) {
      result += units[remainder];
    } else if (remainder < 20) {
      result += teens[remainder - 10];
    } else {
      const tensDigit = Math.floor(remainder / 10);
      const unitsDigit = remainder % 10;
      
      if (tensDigit === 7 || tensDigit === 9) {
        // Special cases for 70s and 90s in French
        if (tensDigit === 7) {
          result += 'soixante';
          if (unitsDigit === 1) {
            result += ' et onze';
          } else if (unitsDigit > 1) {
            result += '-' + teens[unitsDigit - 1];
          } else {
            result += '-dix';
          }
        } else { // tensDigit === 9
          result += 'quatre-vingt';
          if (unitsDigit === 1) {
            result += '-onze';
          } else if (unitsDigit > 1) {
            result += '-' + teens[unitsDigit - 1];
          } else {
            result += '-dix';
          }
        }
      } else if (tensDigit === 8) {
        result += 'quatre-vingt';
        if (unitsDigit === 0) {
          result += 's';
        } else {
          result += '-' + units[unitsDigit];
        }
      } else {
        result += tens[tensDigit];
        if (unitsDigit === 1 && tensDigit === 2) {
          result += ' et un';
        } else if (unitsDigit > 0) {
          result += '-' + units[unitsDigit];
        }
      }
    }
  }
  
  return result;
};

const convertThousands = (num) => {
  if (num === 0) return '';
  
  const thousands = Math.floor(num / 1000);
  const remainder = num % 1000;
  
  let result = '';
  
  if (thousands === 1) {
    result = 'mille';
  } else if (thousands > 1) {
    result = convertHundreds(thousands) + ' mille';
  }
  
  if (remainder > 0) {
    if (result) result += ' ';
    result += convertHundreds(remainder);
  }
  
  return result;
};

const convertMillions = (num) => {
  if (num === 0) return '';
  
  const millions = Math.floor(num / 1000000);
  const remainder = num % 1000000;
  
  let result = '';
  
  if (millions === 1) {
    result = 'un million';
  } else if (millions > 1) {
    result = convertThousands(millions) + ' millions';
  }
  
  if (remainder > 0) {
    if (result) result += ' ';
    result += convertThousands(remainder);
  }
  
  return result;
};

export const numberToFrenchWords = (amount) => {
  if (amount === 0) return 'Zéro dinars algériens';
  
  const integerPart = Math.floor(amount);
  const decimalPart = Math.round((amount - integerPart) * 100);
  
  let result = '';
  
  // Convert integer part
  if (integerPart >= 1000000) {
    result = convertMillions(integerPart);
  } else if (integerPart >= 1000) {
    result = convertThousands(integerPart);
  } else {
    result = convertHundreds(integerPart);
  }
  
  // Add currency (without DA)
  if (integerPart === 1) {
    result += ' dinar algérien';
  } else {
    result += ' dinars algériens';
  }
  
  // Add centimes if there are any
  if (decimalPart > 0) {
    result += ' et ';
    if (decimalPart >= 1000000) {
      result += convertMillions(decimalPart);
    } else if (decimalPart >= 1000) {
      result += convertThousands(decimalPart);
    } else {
      result += convertHundreds(decimalPart);
    }
    
    if (decimalPart === 1) {
      result += ' centime';
    } else {
      result += ' centimes';
    }
  }
  
  // Capitalize first letter
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export default numberToFrenchWords; 